import React, {ReactElement, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory, useLocation} from 'react-router';
import SizeCard from '../../../components/card/Card';
import {LocationState} from '../CheckoutHomePage';
import RupeesIcon from '../../../assets/images/rupees.svg';
export interface DataState {
  addedItem: any;
}

export const ProductAdded = () => {
  const routeState = useLocation<DataState>().state;
  const navigate = useHistory();
  useEffect(() => {
    console.log('INSIDE USEEFFECT');
    console.log(routeState.addedItem);
  }, []);

  const onShopmore = (event: React.SyntheticEvent) => {
    navigate.push('/checkout');
  };
  const goToBag = (event: React.SyntheticEvent) => {
    navigate.push('/checkout/shoppingbag');
  };
  return (
    <div className="container mx-auto z-10 px-8 bg-color">
      <div className="w-auto ">
        <div className="mt-8 grid place-items-center">
          <svg
            className="w-20 h-20 text-white rounded-full bg-green_zero "
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
              d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <div className="mt-6 grid place-items-center">
          <span className="font-roboto text-2xl font-light text-center">
            Item has been added to your shopping bag
          </span>
        </div>
        <div className="mt-3">
          <SizeCard classes="w-full rounded-lg bg-white ">
            <div className="pt-8 ml-4 flex justify-between leading-3">
              <div>
                <span className="font-medium font-roboto">Max fashion</span>
              </div>
              <div className="text-right mr-4 flex">
                {routeState.addedItem.priceList[0].extSellPrice !== null &&
                routeState.addedItem.priceList[0].sellPrice !==
                  routeState.addedItem.priceList[0].extSellPrice ? (
                  <div className="flex justify-between items-center">
                    <strike>
                      <span className="text-black_zero opacity-30 text-xxs flex justify-start">
                        <img src={RupeesIcon} />
                        <span className="ml-1">
                          {routeState.addedItem.priceList[0].sellPrice}
                        </span>
                      </span>
                    </strike>
                    <span className="flex ml-1">
                      <img src={RupeesIcon} />
                      <span className="ml-1 font-medium">
                        {routeState.addedItem.priceList[0].extSellPrice}
                      </span>
                    </span>
                  </div>
                ) : (
                  <div>
                    <span className=" flex ml-1">
                      {<img src={RupeesIcon} />}{' '}
                      <span className="ml-1 font-medium">
                        {routeState.addedItem.priceList[0].sellPrice}
                      </span>
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="pt-4 ml-4 flex justify-between leading-4">
              <div>
                <span className="text-small leading-1 text-left font-medium font-roboto text-black_zero">
                  {routeState.addedItem.itemDesc}
                </span>
              </div>
              <div className=" text-right mr-4">
                <div>
                  <span className="text-xs font-roboto min-w-min">
                    Colour:<b> {routeState.addedItem.itemColour}</b>
                  </span>
                </div>
                <div style={{minWidth: '100px'}}>
                  <span className="text-xs font-roboto text-left">
                    Size: <b>{routeState.addedItem.itemSize}</b>
                  </span>
                </div>
              </div>
            </div>
            <div className=" ml-4 flex justify-between leading-3 pb-4 ">
              <div></div>
              <div className=" text-right mr-4"></div>
            </div>
          </SizeCard>
        </div>
        <div className="text-xxs text-center mt-3">
          <span className="text-center">
            *Go to shopping bag to know the final price post discount or to edit
            your bag
          </span>
        </div>
        <div className="mt-5 flex -mr-3 bottom-0">
          <button
            onClick={onShopmore}
            className="w-full h-12 mt-6 primary normal text-white font-bold focus:outline-none rounded-lg border border-royal_blue"
            type="submit">
            Shop more
          </button>
          &nbsp;
          <button
            onClick={goToBag}
            className="w-full h-12 mt-6 text-black font-bold focus:outline-none rounded-lg border border-royal_blue"
            type="submit">
            Go to bag
          </button>
        </div>
      </div>
    </div>
  );
};
